export default "__VITE_ASSET__BIE2zUGM__"